<template>
    <!-- DESCR：该页面负责论文出版 -->
    <div class="release-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Proposal to Publish Volume for {{ $route.query.acronym }}</div>
                    <br />
                    <div class="info">
                        Use the form below to edit your proposal and click on "Save". You will be asked to check your data
                        before submission.
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <el-row :gutter="10">
            <el-col :span="24">
                <div style="margin-bottom: 20px;">
                    <h4 class="section">Volume Information</h4>
                    <el-text size="small">Enter the volume information. If you are not sure about some items, use your best
                        guess.</el-text>
                </div>
                <el-card class="box-card">
                    <el-form ref="ruleForm1" :model="volumeForm" label-width="260px" label-position="top">
                        <el-text style="font-weight: 700;margin-bottom: 10px;display: inline-block;">Volume
                            acronym.</el-text>
                        <el-form-item prop="acronym" :rules="[{ required: false }]">
                            <template #label>
                                <el-text size="small">Enter the volume acronym.</el-text>
                            </template>
                            <el-input v-model="volumeForm.acronym" style="width:700px"></el-input>
                        </el-form-item>
                        <el-text style="font-weight: 700;margin-bottom: 10px;display: inline-block;">Volume title.</el-text>
                        <el-form-item prop="title" :rules="[{ required: true, message: 'title Cannot be empty' }]">
                            <template #label>
                                <el-text size="small">Enter the full title of the volume.</el-text>
                            </template>
                            <el-input v-model="volumeForm.title" style="width:700px"></el-input>
                        </el-form-item>
                        <el-text style="font-weight: 700;margin-bottom: 10px;display: inline-block;">Volume area or
                            areas.</el-text>
                        <el-form-item prop="primaryarea"
                            :rules="[{ required: true, message: 'primaryarea Cannot be empty' }]">
                            <template #label>
                                <el-text size="small">Select the main area to which your volume belongs.</el-text>
                            </template>
                            <el-select v-model="volumeForm.primaryarea" placeholder="Please select a area">
                                <el-option :value="item.value" :label="item.label" v-for="item in areaList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="secondaryarea"
                            :rules="[{ required: true, message: 'secondaryarea Cannot be empty' }]">
                            <template #label>
                                <el-text size="small">If your volume fits in more than one area, select the second most
                                    relevant area.</el-text>
                            </template>
                            <el-select v-model="volumeForm.secondaryarea" placeholder="Please select a area">
                                <el-option :value="item.value" :label="item.label" v-for="item in areaList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item prop="belongs" :rules="[{ required: true, message: 'belongs Cannot be empty' }]">
                            <template #label>
                                <el-text size="small">If your volume does not fit into our area classification, please write
                                    some notes about the
                                    area or areas your volume belongs too.</el-text>
                            </template>
                            <el-input type="textarea" :rows="2" v-model="volumeForm.belongs" style="width:700px"></el-input>
                        </el-form-item>
                        <el-text style="font-weight: 700;margin-bottom: 10px;display: inline-block;">Publication
                            date.</el-text>
                        <el-form-item prop="publicdate" :rules="[{ required: true, message: 'areas Cannot be empty' }]">
                            <template #label>
                                <el-text size="small">The expected publication date.</el-text>
                            </template>
                            <el-date-picker type="date" placeholder="Please select a date" v-model="volumeForm.publicdate"
                                style="width: 400px" format="YYYY-MM-DD" value-format="YYYY-MM-DD"></el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-text size="small">Tick the following box if the publication date is strict, for example,
                                    if you would like to
                                    have all papers published before the conference.</el-text>
                            </template>
                            <el-checkbox v-model="volumeForm.isstrict">
                                <el-text size="small">the publication date is strict, the volume must be published bythis
                                    date</el-text>
                            </el-checkbox>
                        </el-form-item>
                        <el-text style="font-weight: 700;margin-bottom: 10px;display: inline-block;">Number of
                            papers.</el-text>
                        <el-form-item prop="number" :rules="[{ required: true, message: 'number Cannot be empty' }]">
                            <template #label>
                                <el-text size="small">Enter the expected number of papers, If you are not sure, enter your
                                    best guess.</el-text>
                            </template>
                            <el-input v-model="volumeForm.number" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <template #label>
                                <el-text size="small">Are the volume papers already selected?</el-text>
                            </template>
                            <el-checkbox v-model="volumeForm.isselected">
                                <el-text size="small">the papers are already selected</el-text>
                            </el-checkbox>
                        </el-form-item>
                        <el-text style="font-weight: 700;margin-bottom: 10px;display: inline-block;">Other
                            information.</el-text>
                        <el-form-item>
                            <template #label>
                                <el-text size="small">If you have any other relevant information, please enter it
                                    here.</el-text>
                                <br>
                                <el-text size="small">Please do not enter anything lengthy, like your call for papers or any
                                    other information we can find on your conference Web page.</el-text>
                            </template>
                            <el-input type="textarea" :rows="2" v-model="volumeForm.otherinfo"
                                style="width:700px"></el-input>
                        </el-form-item>
                    </el-form>
                </el-card>
            </el-col>
            <el-col :span="24">
                <div style="margin-bottom: 20px;">
                    <h4 class="section">Customer Details</h4>
                    <el-text size="small">If your proposal is accepted, we will send you a publishing agreement to sign, To
                        this end, we need a customer information.</el-text>
                    <br>
                    <el-text size="small">Thecustomer can be an oroanization (for example, a university), or a person (for
                        example, yourself ). Please fill out the customerinformation.</el-text>
                </div>
                <el-card class="box-card">
                    <el-form ref="ruleForm2" :model="volumeForm" label-width="160px">
                        <el-form-item prop="kind" :rules="[{ required: true, message: 'kind Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Customer kind:</el-text>
                            </template>
                            <el-radio-group v-model="volumeForm.kind">
                                <el-radio label="person" />
                                <el-radio label="organization" />
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item prop="name" :rules="[{ required: true, message: 'name Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Name:</el-text>
                            </template>
                            <el-input v-model="volumeForm.name" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" :rules="[{ required: true, message: 'Phone Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Phone:</el-text>
                            </template>
                            <el-input v-model="volumeForm.phone" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="webpage" :rules="[{ required: false, message: 'webpage Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Web page:</el-text>
                            </template>
                            <el-input v-model="volumeForm.webpape" style="width:700px"></el-input>
                        </el-form-item>
                        <el-divider border-style="dashed" />
                        <el-form-item prop="address1"
                            :rules="[{ required: true, message: 'Address, line 1 Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Address, line 1:</el-text>
                            </template>
                            <el-input v-model="volumeForm.address1" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="address2"
                            :rules="[{ required: false, message: 'Address, line 2 Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Address, line 2:</el-text>
                            </template>
                            <el-input v-model="volumeForm.address2" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="city" :rules="[{ required: true, message: 'city Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">City:</el-text>
                            </template>
                            <el-input v-model="volumeForm.city" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="postcode" :rules="[{ required: true, message: 'Post code Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Post code:</el-text>
                            </template>
                            <el-input v-model="volumeForm.postcode" style="width:700px"></el-input>
                        </el-form-item>
                        <el-form-item prop="country" :rules="[{ required: true, message: 'country Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">Country/region:</el-text>
                            </template>
                            <el-select v-model="volumeForm.country" placeholder="Please select a country">
                                <el-option :value="item.label" :label="item.label" v-for="item in countryList"
                                    :key="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-divider border-style="dashed" />
                        <el-text size="small" style="margin: 20px 0;display: inline-block;">The VAT number should only be
                            given if the customer is from an EU country or the Uk and has a VAT number</el-text>
                        <el-form-item prop="vatnum" :rules="[{ required: false, message: 'vatnum Cannot be empty' }]">
                            <template #label>
                                <el-text style="font-weight: 700;display: inline-block;">VAT number:</el-text>
                            </template>
                            <el-input v-model="volumeForm.vatnum" style="width:700px"></el-input>
                        </el-form-item>
                    </el-form>
                    <el-divider border-style="dashed" />
                    <!-- <div class="submit"><el-button type="primary" :disabled="!agree" @click="submit">Save</el-button>
                    </div> -->
                    <div class="submit"><el-button type="primary" @click="submit">Save</el-button>
                    </div>
                </el-card>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref } from "vue";
import { useRoute, useRouter } from "vue-router";
import request from "../../network/request"
import { ElMessage } from 'element-plus'
import { ArrowLeftBold } from '@element-plus/icons-vue'
import { ElLoading } from 'element-plus'


const router = useRouter()
const route = useRoute()
//国家列表信息（下拉列表）
const countryList = ref([])
//区域列表信息（下拉列表）
const areaList = ref([{ 'id': 1, 'value': 'Accounting and Finance', 'label': 'Accounting and Finance' }, { 'id': 2, 'value': 'Art and Humanities', 'label': 'Art and Humanities' }, { 'id': 3, 'value': 'Biological Sciences', 'label': 'Biological Sciences' }, { 'id': 4, 'value': 'Business and Management', 'label': 'Business and Management' }, { 'id': 5, 'value': 'Chemistry', 'label': 'Chemistry' }, { 'id': 6, 'value': 'Civil Engineering', 'label': 'Civil Engineering' }, { 'id': 7, 'value': 'Computing', 'label': 'Computing' }, { 'id': 8, 'value': 'Earth and Environmental Sciences', 'label': 'Earth and Environmental Sciences' }, { 'id': 9, 'value': 'Economics', 'label': 'Economics' }, { 'id': 10, 'value': 'Education Science', 'label': 'Education Science' }, { 'id': 11, 'value': 'Energy', 'label': 'Energy' }, { 'id': 12, 'value': 'Engineering', 'label': 'Engineering' }, { 'id': 13, 'value': 'Genomics and Bioinformatics', 'label': 'Genomics and Bioinformatics' }, { 'id': 14, 'value': 'Health Sciences', 'label': 'Health Sciences' }, { 'id': 15, 'value': 'Language and Linguistics', 'label': 'Language and Linguistics' }, { 'id': 16, 'value': 'Materials Science', 'label': 'Materials Science' }, { 'id': 17, 'value': 'Mathematics and Statistics', 'label': 'Mathematics and Statistics' }, { 'id': 18, 'value': 'Mechanical Engineering', 'label': 'Mechanical Engineering' }, { 'id': 19, 'value': 'Physics', 'label': 'Physics' }, { 'id': 20, 'value': 'Social Sciences', 'label': 'Social Sciences' }, { 'id': 21, 'value': 'Technology', 'label': 'Technology' }])
//是否同意发布表单协议
const agree = ref(false)
// 表单效验对象
const ruleForm1 = ref(null)
const ruleForm2 = ref(null)

// 出版书表单信息
const volumeForm = ref({
    "cid": route.query.cid,
    "acronym": `${route.query.acronym}`,
    "title": `Proceedings of ${route.query.acronym}`,
    "primaryarea": "Business and Management",
    "secondaryarea": "Biological Sciences",
    "belongs": "1",
    "publicdate": "2024-02-09",
    "isstrict": true,
    "number": "3",
    "isselected": true,
    "otherinfo": "this other info",

    "kind": "person",
    "name": "lalala",
    "phone": "+8615674810207",
    "webpape": "http://cci.com",
    "address1": "guangzhou",
    "address2": "scau",
    "city": "Guangzhou",
    "postcode": "510000",
    "country": "China",
    "vatnum": ""
})

//从后端获取国家列表信息
request.get("/common/country").then((res) => {
    countryList.value = res.data
})
// 发布新会议
const submit = async () => {
    // 将每个表单的验证包装成一个 Promise
    const validateForm1 = new Promise((resolve, reject) => {
        ruleForm1.value.validate(valid => {
            if (valid) resolve(true);
            else reject(false);
        });
    });

    const validateForm2 = new Promise((resolve, reject) => {
        ruleForm2.value.validate(valid => {
            if (valid) resolve(true);
            else reject(false);
        });
    });

    try {
        // 等待所有表单验证完成
        await Promise.all([validateForm1, validateForm2]);
        const loading = ElLoading.service({
            // 加载进度条
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
        // 所有表单验证通过
        request.post("/volume", volumeForm.value).then((res) => {
            if (res.code == 200) {
                ElMessage.success({
                    message: 'save successfully',
                    type: 'success'
                });
                router.push(`/common/detailpublish?vid=${res.data}&acronym=${route.query.acronym}`)
                loading.close()
            }else{
                loading.close()
            }
        })
    } catch (error) {
    }
};

</script>

<style lang="scss">
.release-container {
    .section {
        font-weight: 700;
        font-size: 17px;
        padding: 0;
        -webkit-background-clip: text;
        background-clip: text;
        background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 41, 66));
        color: transparent;
    }

    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

    .submit {
        width: 100%;
        padding: 0;
        display: flex;
        justify-content: center;

        .el-button {
            width: 300px;
        }
    }

    .box-card {
        display: flex;
        justify-content: center;
        position: relative;
        padding: 40px 0;
        margin-bottom: 30px;
        background-color: #eef8ff2e;
    }
}
</style>